// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/userHome/messages/messages.component.less
// module id = 353
// module chunks = 0